// Оформление. Тем две, обе тёмные.
//
// Выбор хранится на устройстве, а не в аккаунте: с телефона и с ноутбука
// человек может хотеть разного, а синхронизировать тут нечего.
//
// Применяется он ещё до отрисовки — из встроенного скрипта в index.html.
// Иначе на каждой загрузке будет вспышка чужой темы.

export const THEMES = [
  {
    id: 'vibe',
    name: 'Vibe',
    hint: 'Тёплый тёмный фон, коралловый акцент, засечки в заголовках.',
  },
  {
    id: 'dark',
    name: 'Dark',
    hint: 'Холодная тёмно-синяя, плотная сетка, гротеск везде.',
  },
];

const KEY = 'hh.theme';
const DEFAULT = 'vibe';

// Темы уже успели пожить под другими именами. Пересохранённый выбор дешевле,
// чем человек, у которого однажды без причины сменилось оформление.
const RENAMED = { claude: 'vibe', stand: 'dark' };

export function currentTheme() {
  const saved = localStorage.getItem(KEY);
  const id = RENAMED[saved] || saved;
  return THEMES.some((t) => t.id === id) ? id : DEFAULT;
}

export function applyTheme(id) {
  const theme = THEMES.some((t) => t.id === id) ? id : DEFAULT;
  localStorage.setItem(KEY, theme);
  // У темы по умолчанию атрибута нет вовсе: так базовые правила остаются
  // базовыми, а не переопределением переопределения.
  if (theme === DEFAULT) document.documentElement.removeAttribute('data-theme');
  else document.documentElement.setAttribute('data-theme', theme);
  return theme;
}
